import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { string, func } from 'prop-types';
import { useLuContentContext } from '../LuContentContext';
import { Container, Text, LinkWrapper, Link, LogosContainer, BlogLuImage, Circle, FacebookIcon, TwitterIcon, InstagramIcon, PinterestIcon } from './LuContentFooter.styles';
import { LuFrom, SocialMedia } from './LuContentFooter.data';

const LuContentFooter = _ref => {
  let {
    onBlogClick,
    onSocialMediaClick
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["onBlogClick", "onSocialMediaClick"]);

  const {
    images: {
      blogImage
    } = {},
    links: {
      blog,
      facebook,
      twitter,
      instagram,
      pinterest
    }
  } = useLuContentContext();
  const items = [{
    id: 'facebook',
    icon: FacebookIcon,
    link: facebook
  }, {
    id: 'twitter',
    icon: TwitterIcon,
    link: twitter
  }, {
    id: 'instagram',
    icon: InstagramIcon,
    link: instagram
  }, {
    id: 'pinterest',
    icon: PinterestIcon,
    link: pinterest
  }];
  return /*#__PURE__*/React.createElement(Container, props, /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement("strong", null, LuFrom), " ", SocialMedia, " ", ''), /*#__PURE__*/React.createElement(LogosContainer, null, blogImage && /*#__PURE__*/React.createElement(LinkWrapper, {
    onClick: onBlogClick
  }, /*#__PURE__*/React.createElement(Link, {
    href: blog
  }, /*#__PURE__*/React.createElement(BlogLuImage, {
    src: blogImage,
    alt: "Blog da Lu",
    lazy: true
  }))), /*#__PURE__*/React.createElement(React.Fragment, null, items.filter(({
    link
  }) => Boolean(link)).map(({
    icon: Icon,
    link,
    id
  }) => {
    return /*#__PURE__*/React.createElement(LinkWrapper, {
      key: id
    }, /*#__PURE__*/React.createElement(Link, {
      "data-testid": "social-links",
      href: link,
      onClick: e => onSocialMediaClick(e, {
        id,
        link
      })
    }, /*#__PURE__*/React.createElement(Circle, null, /*#__PURE__*/React.createElement(Icon, {
      titleAccess: `${id} logo`
    }))));
  }))));
};

LuContentFooter.defaultProps = {
  blogImage: '',
  blogLabel: 'Blog da Lu',
  onBlogClick: () => {},
  onSocialMediaClick: () => {}
};
process.env.NODE_ENV !== "production" ? LuContentFooter.propTypes = {
  blogImage: string,
  blogLabel: string,
  onBlogClick: func,
  onSocialMediaClick: func
} : void 0;
export default LuContentFooter;